import React, { useMemo } from 'react';
import { Select } from 'antd';
import { useGetAllBranches } from '@/shared/api/client/company-resource';

export interface BranchSelectProps {
  disabled?: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  onBlur?: () => void;
}

/**
 * Reusable branch select component.
 * Fetches branches from the company-resource API and displays them as a searchable dropdown.
 *
 * Used for parameter type: BRANCH_SELECT
 */
const BranchSelect: React.FC<BranchSelectProps> = ({ disabled, placeholder, ...rest }) => {
  const { data, isLoading } = useGetAllBranches({
    query: {
      staleTime: 5 * 60 * 1000,
    },
  });

  const options = useMemo(() => {
    const list = (data || []) as any[];
    return list
      .map((b) => ({
        value: b.branch,
        label: b.brName ? `${b.branch} - ${b.brName}` : b.branch,
      }))
      .filter((o) => !!o.value);
  }, [data]);

  return (
    <Select
      showSearch
      allowClear
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder || 'Select branch'}
      options={options}
      optionFilterProp="label"
      {...rest}
    />
  );
};

export default BranchSelect;
